module.exports = __webpack_public_path__ + "img/cont1.ab1d74e4.png";